import {Component, inject, Signal} from '@angular/core';

import {MeasuresFacade} from '@selpia/measures/data-access';
import {OptionsFacade} from '@selpia/options/data-access';
import {DropdownComponent, LoaderComponent} from '@selpia/shared/ui';
import {NavigationService} from '@selpia/data-batch/history-access';
import {AppConfigFacade} from '@selpia/app-config/data-access';
import {Measure} from '@selpia/shared/models';
import {MonitoringService} from '@selpia/user/tracking';

@Component({
  selector: 'lib-feature-measure-selector',
  imports: [DropdownComponent, LoaderComponent],
  templateUrl: './feature-measure-selector.component.html',
  styleUrl: './feature-measure-selector.component.css',
})
export class FeatureMeasureSelectorComponent {
  readonly #optionsFacade = inject(OptionsFacade);
  readonly #measuresFacade = inject(MeasuresFacade);
  readonly #appConfigFacade = inject(AppConfigFacade);
  readonly #navigationService = inject(NavigationService);
  readonly #monitoringService = inject(MonitoringService);

  protected readonly isLoading: Signal<boolean> = this.#measuresFacade.isLoading;

  protected readonly availableMeasures: Signal<Measure[]> = this.#appConfigFacade.focusMeasures;

  protected readonly focusMeasure: Signal<Measure | undefined> = this.#optionsFacade.focusMeasure;

  updateFocusMeasure(measure: Measure | undefined) {
    if (measure) {
      this.#navigationService.setFocusMeasure(measure);
      this.#monitoringService.logEvent('MeasureChanged', {measure: measure.code, view: "Tilegrid"});
    }
  }
}
